// extracted by mini-css-extract-plugin
export default {"container":"SignupForm_container__v144X","label":"SignupForm_label__cHR4+","inputContainer":"SignupForm_inputContainer__h0E+a"};